import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import axios from "axios";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageFour from "./PageFour";
import LoadingPage from "./LoadingPage";

const PageThree = ({ idJadwalCbt, idKelas, kodeTahunAjaran, schoolName }) => {
    const [fetching, setFetching] = useState(false);
    const [subProfilList, SetSubProfilList] = useState([]);
    const [pageAssesment, SetPageAssesment] = useState([]);
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_THREE, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .catch(function (error) {
                    console.error("Error Response Page Two", error);
                });

            if (response) {
                if (response.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Three ", responseAPI);
                    console.log("====================================");

                    SetSubProfilList(responseAPI.subProfilList);
                    SetPageAssesment(responseAPI.listResponseDetailAsessment);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <div>
            {pageAssesment.map((listPage, a) => {
                return (
                    <div key={a}>
                        <div className="report-page">
                            <div className="header-second-page">
                                <GridInline width={"100%"}>
                                    <GridInline width={"80%"}>
                                        <LabelTitle label={"Placement Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                                        <LabelTitle label={schoolName} size={18} bolder={500} color={"#fff"} />
                                    </GridInline>
                                    <GridInline width={"20%"}>
                                        <div
                                            style={{
                                                border: "2px solid #fff",
                                                padding: 5,
                                                textAlign: "center",
                                                borderRadius: 10,
                                            }}
                                        >
                                            <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                                        </div>
                                    </GridInline>
                                </GridInline>
                            </div>
                            <Gap height={20} />
                            <div className="section-three">
                                <div className="result">
                                    <GridInline width={"100%"}>
                                        <GridInline width={"80%"}>
                                            <LabelTitle label={"Rekapitulasi Pemetaan Kurikulum Merdeka Belajar"} size={18} bolder={500} color={"#212529"} />
                                            <LabelTitle label={"Berdasarkan Placement"} size={14} bolder={400} color={"#212529"} />
                                        </GridInline>
                                        <GridInline width={"20%"}>
                                            <div
                                                style={{
                                                    padding: 5,
                                                    textAlign: "center",
                                                    backgroundColor: "#FB8500",
                                                }}
                                            >
                                                <LabelTitle label={listPage.namaJurusan} size={14} bolder={700} color={"#fff"} />
                                            </div>
                                        </GridInline>
                                    </GridInline>
                                    <Gap height={20} />
                                    <div className="rekap-table">
                                        <Table size="sm" style={{ fontSize: 10 }}>
                                            <thead style={{ backgroundColor: "#E9ECEF", fontSize: 11, textAlign: "center" }}>
                                                <tr>
                                                    <th
                                                        width="200"
                                                        height="50"
                                                        colSpan={2}
                                                        style={{
                                                            textAlign: "left",
                                                            paddingLeft: 15,
                                                        }}
                                                    >
                                                        Nama Siswa
                                                    </th>
                                                    {subProfilList.map((detailMapel, i) => {
                                                        return <th>{detailMapel.deskripsi}</th>;
                                                    })}
                                                </tr>
                                            </thead>
                                            {listPage.detailSiswa.map((siswa, b) => {
                                                return (
                                                    <>
                                                        <tr
                                                            width="100%"
                                                            height="40"
                                                            style={{
                                                                backgroundColor: "#F8F9FA",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            <td>{b + 1}</td>
                                                            <td
                                                                width="200"
                                                                style={{
                                                                    textAlign: "left",
                                                                }}
                                                            >
                                                                {siswa.namaSiswa}
                                                            </td>
                                                            {siswa.listAsessment.map((score, d) => {
                                                                return <>{score.akademik ? <td>{score.skor}</td> : <td>{score.singkatan}</td>}</>;
                                                            })}
                                                        </tr>
                                                    </>
                                                );
                                            })}
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <Gap height={40} />
                            <div className="reportFooter">
                                <FooterReport color={"#1D3557"} date={dateTime} />
                            </div>
                        </div>
                    </div>
                );
            })}

            {openPage ? <PageFour idJadwalCbt={idJadwalCbt} idKelas={idKelas} kodeTahunAjaran={kodeTahunAjaran} schoolName={schoolName} /> : <LoadingPage />}
        </div>
    );
};

export default PageThree;
